/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscription_timetable.js                                                                       */
/**********************************************************************************************************************/
/* Subscriptions Timetable */
HafasWebapp.prototype.subscriptions.Timetable = function (_me) {

  // History Back
  Hafas.ps.sub('/GUI/closeView/Timetable', Hafas.bind(_me.Controller.Timetable.closeView, _me));
  Hafas.ps.sub('/GUI/restoreView/Timetable', Hafas.bind(_me.Controller.Timetable.restoreView, _me));
  Hafas.ps.sub('/GUI/leaveContext/Timetable', Hafas.bind(_me.Controller.Timetable.cleanup, _me));

  Hafas.ps.sub("/timetable/clearInput", Hafas.bind(_me.Controller.Timetable.clearInput, _me));

  // Initialisiere Haltestellen-Formular
  // Initialisiere Linien-Formular
  Hafas.ps.sub('/timetable/initForm/stop', Hafas.bind(function () {
    Hafas.bind(_me.Controller.Timetable.cleanup, _me)();
    this.Controller.Timetable.selectedInput = "stop";
    Hafas.bind(_me.Controller.Timetable.initStopForm, _me)();
  }, _me));

  // Initialisiere Linien-Formular
  Hafas.ps.sub('/timetable/initForm/line', Hafas.bind(function () {
    Hafas.bind(_me.Controller.Timetable.cleanup, _me)();
    this.Controller.Timetable.selectedInput = "line";
    Hafas.bind(_me.Controller.Timetable.initLineForm, _me)();
  }, _me));

  Hafas.ps.sub('/timetable/set/stops', Hafas.bind(_me.Controller.Timetable.setSelectedDirectionStops, _me));

  // Timetable-Feature aus dem Timetable-Formular triggern
  Hafas.ps.sub('/timetable/search', Hafas.bind(function () {
    /*    var data = {
          lineId: _me.Controller.Timetable.instance.getLineId(),
          callback: Hafas.bind(_me.Controller.Timetable.showResultOverview, _me)
        };
        _me.Controller.Timetable.instance.searchLineDetails(data);*/
    Hafas.bind(_me.Controller.Timetable.showResultOverview, _me)();
  }, _me));

  //** jumpin-Funktion in das Timetable-Feature von extern über URL-Parameter
  Hafas.ps.sub('/timetable/external/jumpin', Hafas.bind(function (params) {
    // Parameter direkt wieder löschen, wird nur für die initiale Erkennung relevant
    delete this.Controller.Common.initialStartSet;

    _me.appContext = "Timetable";

    Hafas.ps.pub('/GUI/tabNavigationHeading/render', []); // Kontext wurde zuvor manuell (nicht über SwitchContext) geändert, daher hier noch einmal aufrufen

    if(params.hasOwnProperty("dirFlg")) {
      _me.Controller.Timetable.instance.setDirectionFlag(params.dirFlg);
    }
    var data = {
      lineId: params.lineId,
      callback: function (result) {
        // Als erstes prüfen, ob mit der übergebenen Line-ID ein Ergebnis gefunden werden konnte
        var resultFromLineIdIsValid = true;
        if(result.error == true) {
          if (Hafas.Config.debug.showDataModel) {
            console.log('+++ Timetable.Jumpin.invalid-line-Id +++ DEBUG Model +++', result);
          }
          resultFromLineIdIsValid = false;
        }
        if(resultFromLineIdIsValid) {
          Hafas.bind(_me.Controller.Timetable.setLineDetailsResult, _me)(result[0]);
          // Direction Flag entweder von den Übergabeparametern übernehmen oder selbst ermitteln
          var dirFlg = _me.Controller.Timetable.instance.getDirectionFlag();
          if(dirFlg == "undefined") {
            Hafas.bind(_me.Controller.Timetable.selectDirectionFlag, _me)({line: result[0], dirText: params.dirText});
          }
          // Überprüfen, ob der übergebene Richtungstext auf eine Richtung im Ergebnis matcht
          var journey = Hafas.bind(_me.Controller.Timetable.getDirectionJourney, _me)({direction: params.dirText});
          // Ob eine "resolvedLocList" gebildet werden kann, hängt davon ab, ob der Richtungstext in der Liste der Richtungen auffindbar ist
          var dirTextIsValid = false;
          if(journey.hasOwnProperty("resolvedLocList")) {
            dirTextIsValid = true;
            Hafas.bind(_me.Controller.Timetable.setDirectionText, _me)(params.dirText);
            _me.Controller.Timetable.instance.setDirection(params.dirText);
          }
          // Mit valider Richtung und start=1 soll direkt zum Linienfahrplan-Ergebnis gesprungen werden
          if(dirTextIsValid && params.start) {
            Hafas.bind(_me.Controller.Timetable.showResultOverview, _me)();
          } else {
            // Zeige das gefüllte Formular an, soweit die Felder gefüllt werden können
            // entweder weil start=1 (Sofortsuche) nicht übergeben wurde
            // Oder weil die übergebenen Daten für eine Suche nicht ausreichen
            _me.Controller.Timetable.selectedInput = "line";
            Hafas.bind(_me.Controller.Timetable.initLineForm, _me)();
          }
        }
        if(!resultFromLineIdIsValid) {
          // Leeres Formular anzeigen, wenn kein Ergebnis mit übergebener Linie-ID gefunden werden konnte
          Hafas.ps.pub('/timetable/initForm/line');
        }
      }
    };
    var loc = _me.Controller.Timetable.instance.getLocation('S');
    if (loc.lid != null) {
      data.stop = loc;
    }
    _me.Controller.Timetable.instance.searchLineDetails(data);
  }, _me));

  //** jumpin-Funktion in das Timetable-Feature aus einem anderen Context
  Hafas.ps.sub('/timetable/linesearch/jumpin', Hafas.bind(function (params) {
    var dataObject = params;
    if(params.hasOwnProperty('objKey')) {
      dataObject = Hafas.Modules.Render.objectKeeper.get(params.objKey);
    }
    // Leave old context, especially to remove old map contents
    Hafas.ps.pub('/GUI/leaveContext/' + dataObject.appContext);

    _me.appContext = "Timetable";

    Hafas.ps.pub('/GUI/tabNavigationHeading/render', []); // Since previous context was changed manually, we call it again here

    if (dataObject.hasOwnProperty('lineId')) {
      _me.Controller.Timetable.instance.setLineId(dataObject.lineId);
    }
    if (dataObject.hasOwnProperty('dirText')) {
      Hafas.bind(_me.Controller.Timetable.setDirectionText, _me)(dataObject.dirText);
      _me.Controller.Timetable.instance.setDirection(dataObject.dirText);
    }

    var requestDateStr = Hafas.Util.date.jsUTCDate2hciDate(new Date()).hciDate;
    if(params.hasOwnProperty('date')){
      requestDateStr = params.date
    }
    _me.Controller.Timetable.instance.setRequestDate(requestDateStr);

    if(dataObject.dirLocation) {
      _me.Controller.Timetable.instance.setLocation(dataObject.dirLocation, "Z");
    }
    if(dataObject.hasOwnProperty("dirFlg")) {
      _me.Controller.Timetable.instance.setDirectionFlag(dataObject.dirFlg);
    }
    var data = {
      lineId: _me.Controller.Timetable.instance.getLineId(),
      callback: function (result) {
        var dirFlg = _me.Controller.Timetable.instance.getDirectionFlag();
        if(dirFlg === "undefined") {
          Hafas.bind(_me.Controller.Timetable.selectDirectionFlag, _me)({line: result[0], dirText: dataObject.dirText});
        }
        var isValid = true;
        if(result.error === true) {
          if (Hafas.Config.debug.showDataModel) {
            console.log('+++ Timetable.Jumpin +++ DEBUG Model +++', result);
          }
          isValid = false;
        } else {
          Hafas.bind(_me.Controller.Timetable.setLineDetailsResult, _me)(result[0]);
          var journey = Hafas.bind(_me.Controller.Timetable.getDirectionJourney, _me)({direction: dataObject.dirText});
          // Ob eine "resolvedLocList" gebildet werden kann, hängt davon ab, ob der Richtungstext in der Liste der Richtungen auffindbar ist
          if (!journey || !journey.hasOwnProperty("resolvedLocList")) {
            isValid = false;
          }
        }
        if (isValid) {
          if (params.useStation) {
            dataObject.start = true;
            Hafas.bind(_me.Controller.Timetable.setSelectedInput, _me)('stop')
          }
          if (dataObject.start) {
            Hafas.bind(_me.Controller.Timetable.showResultOverview, _me)({extId: params.extId});
          } else {
            _me.Controller.Timetable.selectedInput = "line";
            Hafas.bind(_me.Controller.Timetable.initLineForm, _me)();
          }
        } else {
          if (Hafas.Config.debug.showDataModel) {
            console.log('+++ Timetable.Jumpin.journey +++ DEBUG Model +++', journey, dataObject.dirText)
          }
          // Wenn keine valide Linie oder Richtung übergeben wurde, leeres Linien-Formular öffnen
          Hafas.ps.pub('/timetable/initForm/line');
        }
      }
    };
    var tmpLoc = _me.Controller.Timetable.instance.getLocation('S');
    if (tmpLoc.lid != null) {
      data.stop = tmpLoc;
    }
    _me.Controller.Timetable.instance.searchLineDetails(data);

  }, _me));

  /**
   * Jumpin function into the timetable form from another context
   */
  Hafas.ps.sub('/timetable/stopform/jumpin', Hafas.bind(function (locKey) {
    var location = Hafas.Modules.Render.objectKeeper.get(locKey);
    this.Controller.Timetable.selectedLocation = location;
    // Set the request date to the current date to obtain the timetable for the current week when clicking the info button on the SQ.
    var currentDateStr = Hafas.Util.date.jsUTCDate2hciDate(new Date()).hciDate;
    this.Controller.Timetable.instance.setRequestDate(currentDateStr);
    Hafas.ps.pub('/app/switchContext', [{context: 'Timetable', method: 'initStopFormFromSQInfo'}]);
  }, _me));

  // Ergebnisse aus dem Zuglauf verwenden, um Zielhaltestelle für Timetable zu ermitteln (solange das nicht über ein Direction-Flag geht)
  /*  Hafas.ps.sub('/trainroute/results', Hafas.bind(function(result) {
      console.log("set loc /trainroute/results");
      var locationDest = result.stopL[result.stopL.length - 1].locResolved;
      locationDest.type = "Z";
      _me.Controller.Timetable.instance.setLocation(locationDest);
    },_me));*/

  // Ergebnisse aus der Liniensuche verwenden, um Zielhaltestelle für Timetable zu ermitteln (solange das nicht über ein Direction-Flag geht)
  Hafas.ps.sub('/linesearch/results', Hafas.bind(function (result) {
    var locationDest = result.stopList[result.stopList.length - 1].location;
    _me.Controller.Timetable.instance.setDirectionLocation(locationDest);
  }, _me));

  //** Auswahl einer Haltestelle, auf deren Grundlage die Tabelle angefragt wird
  Hafas.ps.sub('/timetable/location/input', Hafas.bind(function (trigger, type) {
    // console.log("+++ /timetable/location/input +++");
    var me = this;
    var location;
    var selectedOption = trigger.options[trigger.selectedIndex];
    if (selectedOption.getAttribute("data-loc-key") != null) {
      var locKey = selectedOption.getAttribute("data-loc-key");
      location = Hafas.Modules.Render.objectKeeper.get(locKey);
    }
    Hafas.ps.pub('/timetable/result/load', [{location: location}]);
  }, _me));

  //** Rendern einer neuen Tabelle triggern
  Hafas.ps.sub('/timetable/result/load', Hafas.bind(function (params) {
    // set destination location (optional)
    Hafas.Util.gui.setVisibility(Hafas("[data-result-container='timetable']"), true);
    if (Hafas.Config.Timetable.showNextDepartures) {
      Hafas.Util.gui.setVisibility(Hafas("[data-timetable-container='departure_wrapper']"), true);
    }
    if (params.location) {
      _me.Controller.Timetable.instance.setLocation(params.location, "S");
    }

    if (params.hasOwnProperty('lineId')) {
      Hafas.ps.pub('/timetable/setLineId', [params.lineId]);
    } else {
      params.lineId = _me.Controller.Timetable.instance.getLineId();
    }
    Hafas.ps.pub('/gui/common/showLoader', [true]);
    params.callback = function (res) {
      // Hafas.ps.pub('/timetable/searchLineDetails')
      Hafas.bind(_me.Controller.Timetable.renderTimetableTable, _me)(res);
    };
    _me.Controller.Timetable.instance.searchSchedules(params);

  }, _me));

  // Liniennummer an das Timetable-Modul übergeben, um per LineMatch-Request danach zu suchen
  Hafas.ps.sub('/timetable/setLine', Hafas.bind(function (line) {
    _me.Controller.Timetable.instance.setLineMatchResult(line);
  }, _me));

  // Linien-Id an das Timetable-Modul übergeben, um per LineDetails-Request danach zu suchen
  Hafas.ps.sub('/timetable/setLineId', Hafas.bind(function (lineId) {
    _me.Controller.Timetable.instance.setLineId(lineId);
  }, _me));

  // Location-Id an das Timetable-Modul übergeben
  Hafas.ps.sub('/timetable/setLocation', Hafas.bind(function (loc, type) {
    _me.Controller.Timetable.instance.setLocation(loc, type);
  }, _me));

  /*  Hafas.ps.sub('/app/events/resize', Hafas.bind(function() {
      Hafas.bind(_me.Controller.Timetable.buildTimetables, _me)();
    },_me));*/

  // Save a current journey
  Hafas.ps.sub('/common/result/journey', Hafas.bind(function (journey) {
    _me.Controller.Timetable.currentJourney = journey;
  }, _me));

  Hafas.ps.sub('/sq/dataChanged/webapp', Hafas.bind(function () {
    // debugger;
    if (Hafas.Config.Timetable.showNextDepartures && (this.appContext == "Timetable")) {
      Hafas.bind(_me.Controller.Timetable.showNextDepartures, _me)();
    }
  }, _me));

  Hafas.ps.sub('/tq/showTrainroute', Hafas.bind(function(params) {
    var currentLocation =_me.Controller.SQ.instance.getLocation();
    if(currentLocation.name && currentLocation.lid) {
      _me.Controller.Timetable.instance.setLocation(currentLocation, "S");
    }
  }, _me));

  Hafas.ps.sub('/timetable/redrawLine', Hafas.bind(_me.Controller.Timetable.redrawLine, _me));

  Hafas.ps.sub('/timetable/selectStation', Hafas.bind(_me.Controller.Timetable.selectStation, _me));

  Hafas.ps.sub('/timetable/deleteStation', Hafas.bind(_me.Controller.Timetable.deleteStopInput, _me));

  Hafas.ps.sub('/timetable/deleteLine', Hafas.bind(_me.Controller.Timetable.deleteLineInput, _me));

  Hafas.ps.sub('/timetable/set/direction', Hafas.bind(_me.Controller.Timetable.setDirectionText, _me));

  Hafas.ps.sub('/timetable/jumpin', Hafas.bind(_me.Controller.Timetable.jumpinTimetable, _me));

  Hafas.ps.sub("/suggest/selectitem/TimetableStopInput", Hafas.bind(function (hfsLocObj, instance, isValidation) {
    var timetableInput = Hafas('#TimetableStopInput', false);
    var locationName = Hafas.Util.getLocationAttribute(hfsLocObj, "name");
    if (timetableInput && locationName) {
      timetableInput.value = locationName;
    }
    if (Hafas.Config.Favorites.addLocationOnSuggest) {
      Hafas.bind(_me.Controller.Timetable.addLocationToHistory, _me)({location: hfsLocObj});
    }
    Hafas.bind(_me.Controller.Timetable.processStopInput, _me)({loc: hfsLocObj});
  }, _me));

  Hafas.ps.sub('/timetable/submit', Hafas.bind(_me.Controller.Timetable.submitTimetableForm, _me));

  Hafas.ps.sub('/timetable/addLineToFav', Hafas.bind(_me.Controller.Timetable.saveLineAsFavorite, _me));
  Hafas.ps.sub('/timetable/removeLineFromFav', Hafas.bind(_me.Controller.Timetable.deleteLineFromFavorite, _me));

  // ************ GUI **************** //
  // Container anzeigen und ausblenden
  Hafas.ps.sub('/gui/common/showTarget', Hafas.bind(_me.Controller.Timetable.GUI.common.showTarget, _me));
  // Loader anzeigen und ausblenden
  Hafas.ps.sub('/gui/common/showLoader', Hafas.bind(_me.Controller.Timetable.GUI.common.showLoader, _me));
  // ein beliebiges Element aktiv schalten und alle anderen einer Klasse inaktiv schalten
  Hafas.ps.sub('/gui/common/toggleElementClass', Hafas.bind(_me.Controller.Timetable.GUI.common.toggleElementClass, _me));

  Hafas.ps.sub('/gui/form/toggle/loading', Hafas.bind(_me.Controller.Timetable.GUI.form.toggleLoadingView, _me));

};
